import Navbar from "./components/Navbar";
import Router from "./router/Router";

function App() {
  return (
    <>
      <div>
        <Navbar />
        <Router />
      </div>
    </>
  );
}

export default App;
